import { bool } from "prop-types";
import { forwardRef } from "react";

import FnrAccentShineButton from "UI/FnrButton3/FnrAccentShineButton";
import { marketingColors } from "UI/colors";

import { addOpacity } from "Utilities/Colors/colorUtils";

const PopperButton = forwardRef(({ showPopover, isFlashing, ...rest }, ref) => (
  <FnrAccentShineButton
    active={showPopover}
    // an open popover is already the loudest thing on the button, so the flash
    // stands down while it's up
    isFlashing={isFlashing && !showPopover}
    flashToColor={addOpacity(marketingColors.lightBlue, 0.2)}
    {...rest}
    ref={ref}
  />
));

PopperButton.propTypes = { showPopover: bool, isFlashing: bool };

export default PopperButton;
